import { TranslationQuery } from 'next-translate'
import { Children, PropsWithChildren } from 'react'

import { Translated } from '@/components/Translated'

export type ComponentMap = Record<string, React.ReactNode>

type Props = PropsWithChildren<{
  components?: ComponentMap
  values?: TranslationQuery
}>

/**
 * @deprecated The < TokenSupport > component should not be used.
 * You should use < Translated i18Key='your:translation-key' > component instead
 */
export const TokenSupport: React.FC<Props> = ({ children, components, values }) => {
  return (
    <>
      {Children.map(children, function (child) {
        if (typeof child === 'string') {
          return <Translated components={components} i18Key={child} values={values} />
        }
        return child
      })}
    </>
  )
}
